import { useEditor } from '@smartfire/js-block-engine';
import apiFetch from '@wordpress/api-fetch';
import clsx from 'clsx';
import { useState } from 'react';
import Button from '../../../button/block';
import { Loading } from '../../index';
import { validate } from 'disposable-email';
import style from './style.module.scss';

const Form = ({ redirectTo }) => {
    const { isEditing } = useEditor();
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const Wrapper = isEditing ? 'div' : 'form';

    const handleSignupRequest = (e) => {
        e.preventDefault();

        if (!validate(email)) {
            setErrorMessage('Les adresses email jetables ne sont pas autorisées.');
            return;
        }

        setErrorMessage('');
        setIsLoading(true);
        apiFetch({
            path: '/myhand-user/v1/signup-request',
            method: 'POST',
            data: { email },
        }).then(
            (res) => window.location.replace(`${redirectTo}?data=${res}`),
            (err) => {
                setErrorMessage(err);
                setIsLoading(false);
            },
        );
    };

    return (
        <Wrapper className={style.form} onSubmit={isEditing ? null : handleSignupRequest}>
            <div className={clsx(style.field, errorMessage && style.error)}>
                <label htmlFor="email">Email</label>
                <input type="email" name="email" id="email" onChange={(e) => setEmail(e.target.value)} required />
                {errorMessage && <p>{errorMessage}</p>}
            </div>

            {isLoading ? (
                <div className={style.loading}>
                    <Loading onViewPortAppear={() => {}} isTextPrinted={false} isLoading />
                </div>
            ) : (
                <Button
                    classNames={style.submit}
                    text="JE M’INSCRIS"
                    aspect="contained"
                    backgroundContained={style.green}
                    colorContained={style.blue}
                    position="right"
                    Wrapper="button"
                    inspector={false}
                    type="submit"
                    disabled={isLoading}
                />
            )}
        </Wrapper>
    );
};

export default Form;
